// « J'ai oublié mon mot de passe » — la demande.
//
// L'ÉCRAN DIT LA MÊME CHOSE DANS TOUS LES CAS, et ce n'est pas de la
// paresse : une réponse qui distinguerait « adresse connue » de « adresse
// inconnue » ferait de cette page un annuaire. On y testerait des adresses
// jusqu'à savoir lesquelles ont un compte chez un transporteur donné.
//
// La contrepartie est un message un peu plus long — « SI un compte existe » —
// et une phrase sur les indésirables, parce que la première cause d'un
// e-mail « jamais reçu » est un filtre anti-spam, pas une panne.
import { useState } from "react";
import { Link } from "react-router-dom";

import api from "../api";
import { useMarque } from "../marque";

function messageErreur(err, defaut) {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail) && detail[0]?.msg) return detail[0].msg;
  return defaut;
}

export default function MotDePasseOublie() {
  const marque = useMarque();
  const [email, setEmail] = useState("");
  const [envoye, setEnvoye] = useState(false);
  const [enCours, setEnCours] = useState(false);
  const [erreur, setErreur] = useState("");

  const demander = (e) => {
    e.preventDefault();
    setEnCours(true);
    setErreur("");
    api
      .post("/mot-de-passe-oublie", { email })
      .then(() => setEnvoye(true))
      // Un 429 (trop de demandes) est le seul refus que l'utilisateur puisse
      // voir : il est légitime de le lui dire, il porte le délai d'attente.
      .catch((err) =>
        setErreur(messageErreur(err, "Demande impossible pour le moment."))
      )
      .finally(() => setEnCours(false));
  };

  return (
    <div className="login-page">
      <div className="login-panel-gauche">
        {marque.logo_url ? (
          <img src={marque.logo_url} alt={marque.nom} className="login-logo" />
        ) : (
          <div className="login-titre">Gestion de flotte</div>
        )}
        <div className="login-tagline">Espace professionnel</div>
      </div>

      <div className="login-panel-droite">
        {envoye ? (
          <div className="login-form">
            <h1 className="login-marque">Vérifiez vos e-mails</h1>
            <p className="note-succes">
              Si un compte existe pour <strong>{email}</strong>, un lien vient
              d’y être envoyé.
            </p>
            <p className="sous-info">
              Le lien est valable <strong>une heure</strong> et ne peut servir
              qu’une seule fois. S’il n’arrive pas, regardez dans vos
              indésirables avant de redemander — c’est la cause la plus
              fréquente.
            </p>
            <p className="login-oubli">
              <Link to="/login">Retour à la connexion</Link>
            </p>
          </div>
        ) : (
          <form className="login-form" onSubmit={demander}>
            <h1 className="login-marque">Mot de passe oublié</h1>
            <p className="sous-info">
              Indiquez l’adresse de votre compte. Vous recevrez un lien pour
              choisir un nouveau mot de passe.
            </p>

            {erreur && <div className="erreur">{erreur}</div>}

            <div className="login-champ">
              <label htmlFor="oubli-email">Email</label>
              <input
                id="oubli-email"
                type="email"
                placeholder="votre@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="username"
                required
              />
            </div>

            <button
              className="btn-accent login-btn"
              type="submit"
              disabled={enCours}
            >
              {enCours ? "Envoi…" : "Recevoir un lien"}
            </button>

            <p className="login-oubli">
              <Link to="/login">Retour à la connexion</Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
